import { MessageInfoType } from '@/pages/typings';
import { request } from 'umi';

export async function getMessageList (params: {
  messageId?: number;
  pageSize?: number;
  readFlag?: boolean;
  targetPerson: string;
  type?: MessageInfoType
}) {
  return request('/hm/user/message-center/page', {
    params
  })
};

export async function readMessage(params: { id: number }) {
  return request('/hm/user/message-center/read', {
    params
  })
};

export async function deleteMessage(params: { id: number }) {
  return request('/hm/user/message-center/delById', {
    params
  })
};

export async function batchDeleteMessage(params: { readFlag?: boolean }) {
  return request('/hm/user/message-center/batchDel', {
    params
  })
};

export async function batchReadMessage(params: { targetPerson: string, subType?: string }) {
  return request('/hm/user/message-center/batchRead', {
    params
  })
};
